import { render, staticRenderFns } from "./fast-moving-consumer-goods.vue?vue&type=template&id=9803ebce&"
import script from "./fast-moving-consumer-goods.vue?vue&type=script&lang=js&"
export * from "./fast-moving-consumer-goods.vue?vue&type=script&lang=js&"
import style0 from "./fast-moving-consumer-goods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports